"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var dev_exports = {};
__export(dev_exports, {
  dev: () => dev
});
module.exports = __toCommonJS(dev_exports);
var path = __toESM(require("path"), 1);
var import_picocolors = __toESM(require("picocolors"), 1);
var import_setServerGlobals = require("../server/setServerGlobals");
var import_virtualEntryConstants = require("../vite/plugins/virtualEntryConstants");
var import_checkNodeVersion = require("./checkNodeVersion");
var import_install_error_handlers = require("./install-error-handlers");
var import_label_process = require("./label-process");
(0, import_install_error_handlers.installPrepareStackTraceGuard)();
var DAEMON_PORT = 8081;
async function dev(args) {
  var _ref;
  (0, import_label_process.labelProcess)("dev");
  (0, import_checkNodeVersion.checkNodeVersion)();
  (0, import_setServerGlobals.setServerGlobals)();
  var root = process.cwd();
  var daemonServerId;
  var useDaemon = false;
  var forcePort = process.env.ONE_FORCE_PORT ? +process.env.ONE_FORCE_PORT : void 0;
  var envPort = process.env.ONE_PORT ? +process.env.ONE_PORT : void 0;
  var effectivePort = (_ref = forcePort !== null && forcePort !== void 0 ? forcePort : args.port ? +args.port : void 0) !== null && _ref !== void 0 ? _ref : envPort;
  var { isDaemonRunning, registerWithDaemon, unregisterFromDaemon, writeServerFile, removeServerFile } = await import("../daemon/ipc");
  var { getBundleIdFromConfig, getAvailablePort } = await import("../daemon/utils");
  var daemonRunning = await isDaemonRunning();
  var bundleId = getBundleIdFromConfig(root) || path.basename(root);
  if (daemonRunning) {
    if (!effectivePort || effectivePort === DAEMON_PORT) {
      effectivePort = await getAvailablePort(8082, DAEMON_PORT);
      console.log(import_picocolors.default.cyan(`[daemon] Detected running daemon on :${DAEMON_PORT}`));
      console.log(import_picocolors.default.cyan(`[daemon] Using port :${effectivePort} for this server`));
      useDaemon = true;
    }
  }
  var { dev: dev2 } = await import("vxrn/dev");
  var { start, stop } = await dev2({
    mode: args.mode,
    clean: args.clean,
    root,
    debugBundle: args.debugBundle,
    debug: args.debug,
    extraConfig: args.extraConfig,
    server: {
      host: args.host,
      port: effectivePort
    },
    entries: {
      native: import_virtualEntryConstants.virtualEntryIdNative
    }
  });
  var { closePromise } = await start();
  if (useDaemon && bundleId) {
    try {
      daemonServerId = await registerWithDaemon({
        port: effectivePort,
        bundleId,
        root
      });
      console.log(import_picocolors.default.green(`[daemon] Registered as ${bundleId} (${daemonServerId}) \u2192 accessible via :${DAEMON_PORT}`));
      writeServerFile({
        port: effectivePort,
        bundleId,
        root,
        pid: process.pid
      });
    } catch (err) {
      console.log(import_picocolors.default.yellow(`[daemon] Failed to register: ${err}`));
    }
  }
  var cleanup = async function cleanup2() {
    if (daemonServerId) {
      try {
        await unregisterFromDaemon(daemonServerId);
        removeServerFile(root);
      } catch (unused) {
      }
    }
    await stop();
  };
  process.on("beforeExit", function() {
    cleanup();
  });
  process.on("SIGINT", async function() {
    try {
      await cleanup();
    } finally {
      process.exit(2);
    }
  });
  process.on("SIGTERM", async function() {
    try {
      await cleanup();
    } finally {
      process.exit(0);
    }
  });
  process.on("uncaughtException", function(err) {
    try {
      process.stderr.write(`[one dev] uncaught exception
${(0, import_install_error_handlers.formatErrorSafely)(err)}
`);
    } catch (unused) {
    }
  });
  process.on("unhandledRejection", function(err) {
    try {
      process.stderr.write(`[one dev] unhandled rejection
${(0, import_install_error_handlers.formatErrorSafely)(err)}
`);
    } catch (unused) {
    }
  });
  await closePromise;
}
//# sourceMappingURL=dev.js.map
